(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-emporio-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('me-product-carousel')) {
  customElements.define('me-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2 || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.querySelector('.me-carousel-controls').hidden = false;
      this.toggle = this.querySelector('[data-pause-toggle]');
      this.querySelector('[data-prev]').addEventListener('click', () => this.manual(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', (event) => { if (event.target !== this.toggle) { this.paused = true; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
      this.schedule();
    }
    show(step) {
      this.slides[this.index].hidden = true;
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
      this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    manual(step) { this.paused = true; this.show(step); this.schedule(); }
    schedule() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-label', this.toggle.textContent);
      if (!this.paused && !this.hovered && !document.hidden) this.timer = setInterval(() => this.show(1), 8000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
